import { z } from 'zod';
import { moneyMinorSchema } from '../api';
// ── Fixed assets and biomedical maintenance (SRS 10.1) ───────────────────────
export const ASSET_CATEGORY = ['biomedical', 'it', 'furniture', 'vehicle', 'building', 'other'];
export const ASSET_STATUS = ['in_service', 'under_repair', 'standby', 'retired', 'disposed'];
export const MAINTENANCE_KIND = ['preventive', 'calibration', 'breakdown', 'inspection'];
export const MAINTENANCE_STATUS = ['open', 'in_progress', 'resolved', 'closed', 'cancelled'];
export const upsertAssetSchema = z.object({
    code: z.string().trim().toUpperCase().min(2).max(24),
    name: z.string().trim().min(2).max(200),
    category: z.enum(ASSET_CATEGORY).default('biomedical'),
    branchId: z.string().uuid().nullable().optional(),
    departmentId: z.string().uuid().nullable().optional(),
    manufacturer: z.string().trim().max(160).optional(),
    modelNo: z.string().trim().max(120).optional(),
    serialNo: z.string().trim().max(120).optional(),
    location: z.string().trim().max(160).optional(),
    purchasedAt: z.string().datetime().nullable().optional(),
    purchaseCostMinor: moneyMinorSchema.min(0).default(0),
    /** Straight-line depreciation per year, as a percentage of cost. */
    depreciationPct: z.number().min(0).max(100).default(0),
    warrantyEndsAt: z.string().datetime().nullable().optional(),
    amcVendor: z.string().trim().max(160).optional(),
    amcEndsAt: z.string().datetime().nullable().optional(),
    status: z.enum(ASSET_STATUS).default('in_service'),
    notes: z.string().max(2000).optional(),
});
export const maintenanceScheduleSchema = z.object({
    assetId: z.string().uuid(),
    kind: z.enum(['preventive', 'calibration', 'inspection']).default('preventive'),
    intervalDays: z.number().int().min(1).max(3650).default(180),
    nextDueAt: z.string().datetime(),
    instructions: z.string().max(2000).optional(),
    isActive: z.boolean().default(true),
});
export const maintenanceTicketSchema = z.object({
    assetId: z.string().uuid(),
    scheduleId: z.string().uuid().nullable().optional(),
    kind: z.enum(MAINTENANCE_KIND).default('breakdown'),
    priority: z.enum(['low', 'normal', 'high', 'critical']).default('normal'),
    description: z.string().trim().min(3).max(4000),
    vendor: z.string().trim().max(160).optional(),
    assignedTo: z.string().uuid().nullable().optional(),
});
export const maintenanceUpdateSchema = z.object({
    status: z.enum(MAINTENANCE_STATUS),
    resolution: z.string().max(4000).optional(),
    vendor: z.string().trim().max(160).optional(),
    costMinor: moneyMinorSchema.min(0).optional(),
    assignedTo: z.string().uuid().nullable().optional(),
    /** Returns the asset to service; a breakdown ticket defaults to doing so. */
    returnToService: z.boolean().default(true),
});
//# sourceMappingURL=assets.js.map